/* raw layout hash: _default-web-layout-1n801y6:46886d49500a85ee91e9e6d3c223b5da5049f5cc5215c19a9db5d21f78586a19 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-1n801y6" — renders its page content through the router outlet.
export default function DefaultWebLayout1n801y6() {
  return <AppShell layoutName="_default-web-layout-1n801y6" menu={LAYOUT_MENUS['_default-web-layout-1n801y6']} />;
}
